







































































































































































































































import Vue from 'vue'
import { mapState } from 'vuex'

import { VueContext } from 'vue-context'

import { DataLog } from '@/types/data-log'

import { Create, Patch, Delete, Start, Stop } from '@/api/data-logger'

export default Vue.extend({
  components: { VueContext },
  data() {
    return {
      // -------------------------------------------------------------------------------------
      // Select option
      // -------------------------------------------------------------------------------------

      /**
       * Data aqcuitition mode.
       *
       * Currently only cyclic mode ovailable on server
       */
      optsAqcuititionMode: [
        { value: 'cyclic', text: 'Cyclic' },
        { value: 'condition', text: 'On condition' },
      ],

      /**
       * Retention policy expiration duration.
       *
       * Refer to influx retention policy for more information.
       */
      optsDuration: [
        { value: '1d', text: '1 day' },
        { value: '2d', text: '2 days' },
        { value: '4d', text: '4 days' },
        { value: '1w', text: '1 week' },
        { value: '2w', text: '2 weeks' },
        { value: '4w', text: '4 weeks' },
        { value: '8w', text: '8 weeks' },
        { value: '16w', text: '16 weeks' },
        { value: '32w', text: '32 weeks' },
        { value: '64w', text: '64 weeks' },
        { value: '128w', text: '128 weeks' },
        { value: '256w', text: '256 weeks' },
      ],

      /**
       * Retention policy sharding.
       *
       * Refer to influx retention policy for more information.
       */
      optsSharding: [
        { value: '1h', text: '1 hour' },
        { value: '1d', text: '1 day' },
        { value: '1w', text: '1 week' },
        { value: '2w', text: '2 weeks' },
        { value: '4w', text: '4 weeks' },
      ],

      /** Id of selected datalog. */
      selectedId: -1,

      newDataLog: {} as DataLog,
    }
  },
  computed: {
    ...mapState('datalog', { model: 'items' }),
  },

  methods: {
    // ---------------------------------------------------------------
    // Operasi database
    // ---------------------------------------------------------------

    async create() {
      await Create(this.newDataLog)
    },

    /**
     * Ambil list datalog dari database menggunakan vuex action.
     */
    async getDatalog() {
      await this.$store.dispatch('datalog/find')
    },

    /**
     * Simpan perubahan data ke database
     */
    async patch(id: number, data: DataLog) {
      await Patch(id, data)
      await this.getDatalog()
    },

    /** Hapus konfigurasi datalog dari database dan  */
    async delete(id: number) {
      await Delete(id)
    },

    // ---------------------------------------------------------------
    // Common
    // ---------------------------------------------------------------

    /**
     * Initialize new data
     *
     * - Set id menjadi 0 agar pada saat disimpan dibuatkan id oleh sistem database.
     * - Set nama menjadi kosong, nantinya nama wajib diisi dan harus unik.
     * - Set enabled menjadi false, enabled ini adalah fungsi auto start datalogging.
     * - Set duration atau maksimal umur data menjadi 64 minggu.
     * - Set sharding atau pengelompokan file datalog menjadi setiap 1 minggu.
     * - Set standar metode data logging menjadi cyclic atau berdasarkan interval waktu.
     * - Set standar nilai logging cycle menjadi 10 detik.
     * - Set description menjadi ''.
     */
    initializeNewData() {
      this.newDataLog = {
        id: 0,
        name: '',
        enabled: false,
        duration: '64w',
        shard: '1w',
        loggingMethod: 'cyclic',
        loggingCycle: 10000,
        description: '',
        items: [],
      }
    },

    validate(dl: DataLog): boolean {
      // Validate name
      if (dl.name.length < 2) {
        this.$toast.warning('Length of datalog name minimum is 2 character!')
        return false
      }

      if (dl.loggingCycle < 100) {
        this.$toast.warning(
          'Aqcuitition must be greater than or equal with 100 milliseconds.'
        )
        return false
      }

      return true
    },

    /**
     * Ketika id yang dipilih berubah.
     */
    onSelectedIdChanged() {
      this.$emit('onSelectedIdChanged', this.selectedId)
    },

    // --------------------------------------------------------------
    // Even pada keybord dan mouse
    // --------------------------------------------------------------

    /**
     * Ketika baris data pada tabel diklik.
     */
    onRowClicked(id: number) {
      this.selectedId = id
    },

    onRightMouseClicked($event: MouseEvent, id: number) {
      this.selectedId = id
      // eslint-disable-next-line
      ;(this as any).$refs.menu.open($event)
    },

    /**
     * Ketika fokus ada pada baris data dan tombol enter ditekan
     */
    onEnterKeyUp(id: number, dl: DataLog) {
      if (!this.validate(dl)) {
        return
      }
      this.patch(id, dl)
    },

    /**
     * Ketika fokus ada pada baris data dan tombol escape(ESC) ditekan
     */
    onEscapeKeyUp() {
      this.getDatalog()
    },

    /**
     * Ketikafokus ada pada baris data baru dan tombol enter ditekan
     */
    async onNewDataEnterKeyUp() {
      if (!this.validate(this.newDataLog)) {
        return
      }
      await this.create()
      this.initializeNewData()
      await this.getDatalog()
    },
    /**
     * Ketikafokus ada pada baris data baru dan tombol escape (ESC) ditekan
     */
    async onNewDataEscapeKeyUp() {
      this.initializeNewData()
    },

    onNewDataClicked() {
      this.selectedId = -1
    },

    async onEnabledChanged(dl: DataLog) {
      await this.patch(dl.id, dl)
    },

    // ---------------------------------------------------------------------
    // Context Menu & Modal
    // ---------------------------------------------------------------------

    /**
     * Ketika menu start pada context menu diklik,
     * kirim permintaan ke server untuk menjalankan routine datalog.
     */
    async onContextMenuStart() {
      await Start(this.selectedId)
      await this.getDatalog()
    },

    /**
     * Ketika menu stop pada context menu diklik,
     * kirim permintaan ke server untuk menghentikan routine datalog.
     */
    async onContextMenuStop() {
      await Stop(this.selectedId)
      await this.getDatalog()
    },

    /**
     * Ketika menu delete pada context menu diklik,
     * Tampilkan dialog untuk memastikan bahwa user benar-benar ingin menghapus datalog.
     *
     * Proses penghapusan akan dijalankan setelah user mengonfirmasi dengan cara klik tombol yes pada dialog.
     */
    onContextMenuDelete() {
      // eslint-disable-next-line
      ;(this as any).$refs.dialogDelete.show()
    },

    async onContextMenuRefresh() {
      await this.getDatalog()
    },

    async onDialogDeleteOk() {
      await this.delete(this.selectedId)
      await this.getDatalog()
    },
  },

  watch: {
    selectedId: function() {
      this.onSelectedIdChanged()
    },
  },

  async created() {
    this.initializeNewData()
    await this.getDatalog()
  },
})
